import React, { useState, useEffect } from "react";
import "../../css/Login.css";
import {
    Routes,
    Route,
    useNavigate
} from "react-router-dom";
import SignUpPage from "../../modules/Login/SignUpPage";
import ResetPassword from "../../modules/Login/ResetPassword";
import ForgetPassword from "../../modules/Login/ForgetPassword";
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import { APILOGIN } from "../../services/APIServices";

const LoginPage = (props) => {
    const [loginMsg, setLoginMsg] = useState();
    const [state, setState] = useState({
        open: false,
        vertical: 'top',
        horizontal: 'center',
        msgType: ''
    });
    const ApiContext = "login"
    const { vertical, horizontal, open, msgType } = state;
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [remember, setRemember] = useState(false);
    let lData = {};
    const navigate = useNavigate();

    useEffect(() => {
        const usernameR = localStorage.getItem('usernameR');
        const passwordR = localStorage.getItem('passwordR');
        const remember = localStorage.getItem('remember');
        if (remember === 'true') {
            setUsername(usernameR);
            setPassword(passwordR);
            setRemember(true);
        } 
    }, []);

    const handleUserChange = event => {
        setUsername(event.target.value);
    };

    const handlePassChange = event => {
        setPassword(event.target.value);
    };

    const handleChange = event => {
        setRemember(current => !current);
    };

    const forgetPasswordRoute = () => {
        navigate("/forgetPassword");
    }

    const loginRoute = () => {
        navigate("/login");
    }

    const handleClick = (newState) => {
        setState({ open: true, ...newState });
    };

    const handleClose = () => {
        setState({ ...state, open: false });
    };

    async function funcLogin() {
        //remember username and password 
       const data = { username, password, remember }
        if (data.remember === true) {
            localStorage.setItem("usernameR", data.username);
            localStorage.setItem("passwordR", data.password);
            localStorage.setItem("remember", data.remember);
        } else {
            localStorage.removeItem("usernameR");
            localStorage.removeItem("passwordR");
            localStorage.removeItem("remember");
        }

        // APILOGIN();

        // let response;
        let resData = await APILOGIN(data, ApiContext)
            .then(res => {
                // response = res;
                 
                return res
            })
            .catch(err => {
                setLoginMsg("Login Failed ! Please Re Check Your creadentials.");

                handleClick({
                    vertical: 'top',
                    horizontal: 'center',
                    msgType: 'error'
                });
            })

        if (resData) {
            handleClick({
                vertical: 'top',
                horizontal: 'center',
                msgType: 'success'
            });
            setLoginMsg("Logged In");
            if (localStorage.getItem('token')) {
                localStorage.removeItem('token');
                localStorage.setItem("token", resData.data.token);
                localStorage.setItem("userName", resData.data.username);
                localStorage.setItem("name", resData.data.name);
                localStorage.setItem("userId", resData.data.id);
            }
            else {
                localStorage.setItem("token", resData.data.token);
                localStorage.setItem("userName", resData.data.username);
                localStorage.setItem("name", resData.data.name);
                localStorage.setItem("userId", resData.data.id);
            }
            props.setToken(() => (resData.data.token))
        }       
    }

    return (
        <React.Fragment>
            <Snackbar
                anchorOrigin={{ vertical, horizontal }}
                open={open}
                onClose={() => { handleClose() }}
                autoHideDuration={4000}
            >
                <Alert severity={msgType}>{loginMsg}</Alert>
            </Snackbar>
            <div className="login-container">
            <div className="df jcc ais">
                {/* <div className="imageLeft">
                    <div className="toplogo">
                        <img src={logo} alt="logo" className="logoAnimate" />
                    </div>

                    <h5>Consent &amp; Preference Management Platform</h5>
                  <div className="imgBox">
                        <img className="loginfcImg" src={fclogo} alt="fc" />
                        <img className="loginImg" src={login} alt="decidd" />
                        </div>

                </div> */}
                <div className="formRight ">
                    <div className="login-tabs">
                        <div className="buttons">
                            <button className="tab-1 active" onClick={loginRoute}>
                                Login
                            </button>
                            {/* <button className="tab-2" onClick={signUpRoute}>
                                SignUp
                            </button> */}
                        </div>
                    </div>
                    <div className="wrap jcc df">
                        <div className="form_wrapper content-1 active">
                            <form method="post">
                                <div className="login_input">
                                    <label htmlFor="">User Name/Email Id</label>
                                    <input type="email" id="username" name="username" autoComplete="off" value={username} defaultValue={username} onChange={handleUserChange} />
                                </div>
                                <div className="login_input">
                                    <label htmlFor="">Password</label>
                                    <input type="password" id="password" name="password" value={password} defaultValue={password} autoComplete="new-password" onChange={handlePassChange} />
                                </div>
                                <div className="login_chx">
                                    <input type="checkbox" id="Remember" className="checkbx" name="Remember" defaultValue="" onChange={handleChange} checked={remember} />
                                    <span>Remember me?</span>
                                </div>
                                <div className="btn_wrap">
                                    <button className="login_btn" onClick={(e) => {
                                        e.preventDefault();
                                        funcLogin()
                                    }}>Login</button>
                                    <p className="forget_pswd">
                                        <button
                                            name="forgetPassword"
                                            onClick={forgetPasswordRoute}
                                        >
                                            Forget Password?
                                        </button>
                                    </p>

                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>

        </div>
        </React.Fragment>
    );
}

// export default LoginPage;

const LoginPageRoutes = (props) => {
    return (
        <Routes>
            <Route path="/" element={<LoginPage setToken={props.setToken}/>} />
            <Route path="/forgetPassword" element={<ForgetPassword />} />
            <Route path="/login" element={<LoginPage setToken={props.setToken}/>} />
            <Route path="/signUp" element={<SignUpPage />} />
            <Route path="/home" element={<LoginPage setToken={props.setToken}/>} />
            <Route path="*" element={<LoginPage setToken={props.setToken}/>} />
            <Route path="/api/auth/resetPassword" element={<ResetPassword />} />
        </Routes>
    );
}

export default LoginPageRoutes;